import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths, SortDirection } from 'models/enums';

import QueryKeys from './keys';

// Response type for paginated contacts API
export type PaginatedContactsResponse = {
    total: number;
    offset: number;
    limit: number;
    data: unknown[];
};

type UsePaginatedContactsParams = {
    options?: {
        limit?: number;
        offset?: number;
        sortColumn?: string;
        sortDirection?: SortDirection;
        segmentId?: number;
        searchTerm?: string;
    };
    reactQueryOptions?: UseQueryOptions<PaginatedContactsResponse, Error>;
};

const usePaginatedContacts = ({ options = {}, reactQueryOptions }: UsePaginatedContactsParams = {}) => {
    const { limit, offset, sortColumn, sortDirection, segmentId, searchTerm } = options;

    const queryKey = QueryKeys.CONTACTS_PAGINATED(segmentId, searchTerm, offset, limit, sortColumn, sortDirection);

    const params = {
        ...(segmentId && { segmentId }),
        ...(sortColumn && sortDirection && { sort: `${sortColumn}:${sortDirection}` }),
        ...(limit !== undefined && { limit }),
        ...(offset !== undefined && { offset }),
        ...(searchTerm && { search_term: searchTerm }),
    };

    const axiosOptions = {
        ...(Object.keys(params).length && { params }),
    };

    return useQuery<PaginatedContactsResponse>(
        queryKey,
        CuredApiPaths.CONTACTS_PAGINATED,
        reactQueryOptions,
        axiosOptions
    );
};

export default usePaginatedContacts;
